var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.53 2.483a1.26 1.26 0 0 0-.375-.905L23.952.375a1.26 1.26 0 0 0-.9-.375h-.004a1.25 1.25 0 0 0-.893.375l-5.458 5.458H5.947V1.25c0-.69-.56-1.25-1.25-1.25h-.833A3.337 3.337 0 0 0 .53 3.333v18.438A3.424 3.424 0 0 0 3.984 25H24.28c.69 0 1.25-.56 1.25-1.25V7.083c0-.69-.56-1.25-1.25-1.25h-1.583l2.458-2.458c.24-.235.374-.557.375-.893m-10.092 7.934a.28.28 0 0 1-.238-.084.29.29 0 0 1-.083-.235l.158-1.416a1 1 0 0 1 .025-.088l1.641 1.641c-.027.006-.052.02-.08.023zm2.183-.68-1.823-1.825L20.34 3.37l1.822 1.822zm3.306-6.956.618-.617 1.822 1.822-.618.618zm-19.563.552a2.5 2.5 0 0 1 2.5-2.5h.833c.23 0 .417.187.417.417v16.667c0 .23-.187.416-.417.416h-.833c-.958 0-1.869.412-2.5 1.13zM24.28 6.667c.23 0 .417.186.417.416V23.75c0 .23-.187.416-.417.416H3.984a2.583 2.583 0 0 1-2.62-2.408v-.091a2.503 2.503 0 0 1 2.5-2.5h.833c.69 0 1.25-.56 1.25-1.25V6.666h9.917l-.947.946a1.6 1.6 0 0 0-.47.972l-.158 1.42c-.013.138-.039.497 0 .63l-6.592.198c-.23 0-.5-.167-.5.063S7.3 11 7.53 11l1.457.243L9.03 22c0 .23-.23.5 0 .5s.25.23.25 0v-5.834h5.043l-.226 3.75H11.53c-.23 0-.5-.146-.5.084-.23 0 0 .23 0 0h8.5c.46 0 .5-.04.5-.5l.334-6.083a.417.417 0 1 0-.834 0V16H9.28v-4.75h6.129q.06 0 .121-.007l1.424-.162a1.63 1.63 0 0 0 .958-.456l3.954-3.958zm-4.639 10-.11 3.5-4.834.1v-3.6zm4.927-13.883-.612.612-1.822-1.821.612-.613a.43.43 0 0 1 .615.002l1.205 1.203a.43.43 0 0 1 .13.313.43.43 0 0 1-.128.304",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.578 10.5H7.447a.417.417 0 1 0 0 .833h1.25v11.25a.417.417 0 0 0 .833 0V16.75h4.584v3.333h-2.917a.417.417 0 1 0 0 .834h8.333c.46 0 .833-.373.833-.834v-6.25a.417.417 0 1 0-.833 0v2.084h-10v-4.584h5.048zm4.952 6.25v3.333h-4.583V16.75z",
    fill: "#E5A033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.53 0h25v25h-25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProjects);
export default __webpack_public_path__ + "static/media/ic_projects.a6c53e20d4f31ff18c22ccea448c2917.svg";
export { ForwardRef as ReactComponent };